<mat-sidenav
  #sidenav
  mode="side"
  [opened]="true"
  [class.opened-sidenav]="isSidenavOpen"
  [class.collapsed-sidenav]="!isSidenavOpen"
  class="border-0"
>
  <div class="nav-wrapper h-100">
    <!-- <img
      (click)="toggleSidenav()"
      src="assets/images/arrow.png"
      alt="Toggle Sidebar"
      class="arrow-icon"
      [class.collapsed]="!isSidenavOpen"
    /> -->
    <!-- Search Bar -->
    <!-- <div class="search-bar mb-3" *ngIf="isSidenavOpen && !isEdiotrView">
      <div class="input-group">
        <input
          type="text"
          class="form-control form-control-sm w-100"
          placeholder="Search"
        />
        <span class="input-group-text bg-white border-0">
          <img
            src="assets/images/search-icon.png"
            alt="Search Icon"
            class="search-icon"
          />
        </span>
      </div>
    </div> -->
    <!-- <div class="search-bar-line"></div> -->
    <!-- Project Display -->
    <div class="project-display py-2" *ngIf="isSidenavOpen">
      <div class="d-flex align-items-center mx-3 p-2 text-center p-d-wrap rounded-2">
        <!-- <img
          src="assets/images/project-icon.png"
          alt="project-icon"
          class="project-icon me-2"
        /> -->
        <div class="project-name text-truncate">
          {{ projectName }}
        </div>
      </div>
    </div>
    <!-- Navigation Menu -->
    <div class="sidebar pb-3">
      <ng-container
        *ngFor="
          let item of menuItems | sortByKey : 'order' : true;
          let i = index
        "
      >
        <div class="d-flex align-items-center menu-item py-2 px-2 mx-1" 
          [class.selected]="selectedItem?.id === item.id || activeMenuItem?.id === item.id || activeFlyoutParent?.id === item.id"
          (click)="isSidenavOpen && item?.children?.length ? toggleExpand(item) : (item?.menu?.length || item?.children?.length ? openFlyout($event, item) : onItemClick(item))"
          (mouseenter)="!isSidenavOpen ? onMenuItemMouseEnter($event, item) : onHover(item?.icon ?? '', true)"
          (mouseleave)="!isSidenavOpen ? onMenuItemMouseLeave(item) : onHover(item?.icon ?? '', false)" 
          [matTooltip]="!isSidenavOpen ? item.displayName : ''"
          matTooltipPosition="right"
          matTooltipClass="custom-tooltip"
          (keydown.enter)="isSidenavOpen && item?.children?.length ? toggleExpand(item) : (item?.menu?.length || item?.children?.length ? openFlyout($event, item) : onItemClick(item))">
          <div class="d-flex align-items-center justify-content-center flex-grow-1">

            <!-- Icon wrapper (relative for flyout arrow badge) -->
            <div class="nav-icon-wrap">
              <!-- Assets icon -->
              <img *ngIf="item.assetIcon" [src]="('images/editor-tree/' + item.assetIcon) | assetUrl" class="asset-icon" [alt]="item.assetIcon">

              <!-- Nav icon -->
              @if(item?.icon) {
                <img [src]="('images/editor-tree/icons/' + ((hoverState[item?.icon] || selectedItem?.id === item.id || activeFlyoutParent?.id === item.id) ? item?.icon + '-light' : item?.icon) + '.svg') | assetUrl"
                class="nav-icon"
                width="14"
                height="14"
                [alt]="item?.icon">
              }

              <!-- Flyout arrow: collapsed mode only -->
              <span *ngIf="!isSidenavOpen && (item.menu?.length || item.children?.length)" class="flyout-arrow-indicator" [class.flyout-arrow-active]="activeMenuItem?.id === item.id">
                <i class="bi bi-caret-right-fill flyout-arrow-icon"></i>
              </span>
            </div>

            <!-- Item Name (only visible when expanded) -->
            <span *ngIf="isSidenavOpen" class="nav-item-font ms-2 flex-grow-1">{{
              item.displayName
            }}</span>

            <!-- Chevron expand/collapse: expanded mode only -->
            <span *ngIf="isSidenavOpen && item.children?.length > 0" class="mx-1">
              <i [ngClass]="expandedItems.has(item.id) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
            </span>
          </div>

          <img
            *ngIf="item.enableMenu"
            class="menu-items"
            [matMenuTriggerFor]="menu"
            src="assets/images/menu-dots.png"
            alt="icon"
          />

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onMenuClick('refresh', item)">
              Refresh
            </button>
            <button mat-menu-item (click)="onMenuClick('createTestSuite', item)">
              Create new test suite
            </button>
            <button mat-menu-item (click)="onMenuClick('create_test_script', item)">
              Create new test script
            </button>
            <button mat-menu-item (click)="onMenuClick('save_test_script', item)">
              Save test scripts
            </button>
          </mat-menu>
        </div>

        <!-- Inline accordion children: expanded nav only -->
        <div *ngIf="isSidenavOpen && expandedItems.has(item.id) && item.children?.length > 0" class="submenu ps-2">
          <ng-container
            *ngFor="let child of item.children | sortByKey : 'order' : true; let j = index"
          >
            <app-side-nav-item
              [item]="child"
              [index]="j + 1"
              [expandedItems]="expandedItems"
              (itemSelected)="onItemClick($event)"
              [selectedItem]="selectedItem"
            ></app-side-nav-item>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</mat-sidenav>

<ng-template #flyoutTemplate let-item>
  <div class="nav-flyout-panel">
    <div
      *ngFor="let menuItem of (item.menu || item.children)"
      class="flyout-panel-item"
      [class.flyout-panel-item-active]="selectedItem?.id === menuItem.id"
      (click)="onFlyoutItemClick(menuItem)"
      (keydown)="onFlyoutItemClick(menuItem)"
    >
      <span class="flyout-panel-item-label">{{ menuItem.displayName }}</span>
    </div>
  </div>
</ng-template>
